<template>
    <div>
        <form @submit.prevent="setPassword">
            <div class="u-margin-bottom">
                <div v-if="form.errors.first('token')">
                    <svg width="20" height="20" viewBox="0 0 20 20" class="icon | u-margin-right-inline">
                        <use xlink:href="../assets/feather-icons/icons.svg#info"></use>
                    </svg>
                    <span class="authentication__email-info">
                        <small>{{ trans('authentication.password-set.token_required') }}</small>
                    </span>
                </div>
                <text-input
                    v-model="form.email"
                    :error="form.errors.first('email')"
                    :label="trans('authentication.password-set.fields.email')"
                    name="email"
                    class="field__label--register field__input--register | u-full-width"
                    required
                />
                <password-input
                    v-model="form.password"
                    :error="form.errors.first('password')"
                    :label="trans('authentication.password-set.fields.password')"
                    name="password"
                    class="field__label--register field__input--register | u-full-width"
                    required
                />
                <password-input
                    v-model="form.password_confirmation"
                    :error="form.errors.first('password_confirmation')"
                    :label="trans('authentication.password-set.fields.password_confirmation')"
                    name="password_confirmation"
                    class="field__label--register field__input--register | u-full-width"
                    required
                />
                <svg width="20" height="20" viewBox="0 0 20 20" class="icon | u-margin-right-inline">
                    <use xlink:href="../assets/feather-icons/icons.svg#info"></use>
                </svg>
                <span class="authentication__email-info">
                    <small>{{ trans('authentication.password-set.strong_password') }}</small>
                </span>
            </div>

            <div class="layout">
                <div class="layout__item u-1/2-desk">
                    <span class="authentication__required-fields">
                        <small>{{ trans('authentication.password-set.required-fields') }}</small>
                    </span>
                </div>
            </div>

            <nav>
                <button
                    class="btn btn--auth button-blue-submit--ghost | u-margin-bottom-narrow u-full-width"
                    dusk="password-set-button"
                    type="submit"
                >
                    {{ trans('authentication.password-set.button') }}
                </button>
            </nav>
        </form>
    </div>
</template>

<script>
import { Way2Form } from 'relapp-way2forms';

export default {
    props: {
        token: {
            type: String,
            required: false
        },
        email: {
            type: String,
            required: false
        }
    },
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            form: new Way2Form({
                token: this.token,
                email: this.email,
                password: null,
                password_confirmation: null
            })
        };
    },
    methods: {
        /**
         * Submit set password form
         */
        setPassword() {
            this.$emit('submit', this.form);
        }
    }
};
</script>
